<template>
    <BField
        class="ls-select-all-checkboxes"
        :class="{ 'ls-select-all-checkboxes--error-label': getValidation.invalid }"
        :label="label"
        :type="{ 'is-error': getValidation.invalid }"
    >
        <section>
            <BCheckbox
                v-if="options.length > 1"
                v-model="allSelected"
                v-validate="validation"
                name="selectAllCheckbox"
                :disabled="disabled"
                test-id="ls-checkbox-select-all"
                type="is-primary-invert"
                class="ls-select-all-checkboxes--checkbox"
                @input="selectAll"
            >
                <div class="ls-select-all-checkboxes--select-all">Select All</div>
            </BCheckbox>
            <div v-for="option in options" :key="option.id" class="field">
                <BCheckbox
                    v-model="localValue"
                    v-validate="validation"
                    :name="name"
                    :native-value="option.id"
                    :disabled="disabled"
                    test-id="ls-checkbox"
                    type="is-primary-invert"
                    class="ls-select-all-checkboxes--checkbox"
                    @input="areAllSelected"
                >
                    <slot name="option" :option="option" />
                </BCheckbox>
            </div>
        </section>
    </BField>
</template>

<script>
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import _ from 'lodash';

export default {
    name: 'LsSelectAllCheckboxes',
    inject: ['$validator'],
    props: {
        value: VueTypes.array.isRequired,
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
        name: VueTypes.string.isRequired,
        options: VueTypes.arrayOf(
            VueTypes.shape({
                __typename: VueTypes.oneOf(['Schedule', 'Recommendation', 'RequiredService'])
                    .isRequired,
                id: VueTypes.string.isRequired,
                cycle: VueTypes.integer,
                service: VueTypes.shape({
                    name: VueTypes.string,
                }),
                schedule_at: VueTypes.string,
                type: VueTypes.string,
                next_customer_starts_at: VueTypes.string,
                next_customer_ends_at: VueTypes.string,
            })
        ).isRequired.loose,
        label: VueTypes.string,
        disabled: VueTypes.bool.def(false),
        validation: VueTypes.object.def(_.constant(null)),
    },

    data() {
        return {
            allSelected: false,
        };
    },

    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                lsTrackingService.track({
                    event: 'click',
                    target: this.trackId,
                    data: { value },
                });
                this.$emit('input', value);
            },
        },
        getValidation() {
            return lsValidationService.getValidation.call(this, 'checkboxes');
        },
    },

    methods: {
        selectAll() {
            if (this.allSelected) {
                const value = _.map(this.options, 'id');
                lsTrackingService.track({
                    event: 'click',
                    target: this.trackId,
                    data: { value },
                });
                this.$emit('input', value);
            } else {
                this.$emit('input', []);
            }
        },
        areAllSelected(checkboxValues) {
            this.allSelected = _.size(checkboxValues) === _.size(this.options);
        },
    },
};
</script>

<style lang="scss">
.ls-select-all-checkboxes {
    .b-checkbox {
        .control-label {
            padding-left: 9px !important;
            color: $secondary;
        }

        .check {
            border: 1px solid $secondary !important;
            height: 1.2rem !important;
            width: 1.2rem !important;
            border-radius: 2px !important;
            margin-top: 2px;
        }
    }

    .ls-select-all-checkboxes--checkbox {
        align-items: flex-start !important;
    }

    .ls-select-all-checkboxes--select-all {
        font-weight: bold;
        margin: 0 4px;
    }

    .ls-select-all-checkboxes--error-label > .label:not(:last-child) {
        color: $danger;
    }
}
</style>
